const PARTICIPANT_EMAIL_RE = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/;

export type ParticipantDraft = {
  key: string;
  name: string;
  email: string;
};

/** Extract the first email from a stored participant line. */
export function extractParticipantEmail(participant: string): string | null {
  const match = participant.match(PARTICIPANT_EMAIL_RE);
  return match ? match[0].toLowerCase() : null;
}

/** Parse `Name <email>` or bare email/name into editable fields. */
export function parseParticipantLine(participant: string): { name: string; email: string } {
  const trimmed = participant.trim();
  if (!trimmed) return { name: '', email: '' };

  const emailMatch = trimmed.match(PARTICIPANT_EMAIL_RE);
  const email = emailMatch ? emailMatch[0] : '';
  const name = trimmed
    .replace(email, '')
    .replace(/[<>()]/g, '')
    .trim();

  return { name, email };
}

/** Serialize attendee fields back to the `participants` text[] format. */
export function formatParticipantLine(name: string, email: string): string {
  const nameTrim = name.trim();
  const emailTrim = email.trim();
  if (emailTrim) {
    return nameTrim ? `${nameTrim} <${emailTrim}>` : emailTrim;
  }
  return nameTrim;
}

export function participantLinesToDrafts(participants: string[] | null | undefined): ParticipantDraft[] {
  return (participants ?? []).map((line, index) => {
    const parsed = parseParticipantLine(line);
    return {
      key: `participant-${index}`,
      name: parsed.name,
      email: parsed.email,
    };
  });
}

export function draftsToParticipantLines(rows: ParticipantDraft[]): string[] {
  return rows
    .map((row) => formatParticipantLine(row.name, row.email))
    .filter((line) => line.length > 0);
}

export function newParticipantDraft(): ParticipantDraft {
  return {
    key: `participant-${crypto.randomUUID()}`,
    name: '',
    email: '',
  };
}
